export const formatLocationAddress = (
  location:
    | {
        city?: string
        state?: string
        zip?: string
      }
    | null
    | undefined
) => {
  if (!location) return ''

  return [location.city, location.state, location.zip]
    .filter(Boolean)
    .join(', ')
}
